// extracted by mini-css-extract-plugin
export default {"productDescription":"V_-z","featuredDescription":"W_-z","description":"X_-z","more":"Y_-z","descriptionSku":"Z_-z"};